import * as React from 'react'
function SvgLink(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.2 16.6c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-2.2 2.4C8.6 22.8 8 24.4 8 26s.6 3.2 1.8 4.4c2.2 2.2 6.2 2.2 8.4 0l2.4-2.4c.8-.8 2-1 2.8-.2.8.8.8 2 0 2.8L21 33c-1.8 2-4.4 3-7 3-2.6 0-5.2-1-7-3-2-1.8-3-4.4-3-7 0-2.6 1-5.2 3-7zm13.6-2.2c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-8.4 8.4c-.4.4-1 .6-1.4.6-.4 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8zM26 4c2.6 0 5.2 1 7 3 2 1.8 3 4.4 3 7 0 2.6-1 5.2-2.8 7l-2.4 2.4c-.4.4-1 .6-1.4.6-.4 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l2.2-2.4c1.2-1 1.8-2.6 1.8-4.2s-.6-3.2-1.8-4.4c-2.2-2.2-6.2-2.2-8.4 0L19.4 12c-.8.8-2 .8-2.8 0-.8-.8-.8-2 0-2.8L19 7c1.8-2 4.4-3 7-3z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgLink
